/**
 * The signed-in user's id from an IAM access token: its `sub` claim (32 lowercase hex or a ULID), taken as-is.
 * "" when the token can't be read or has no string `sub`: callers fall back to `/api/user/me` `id`.
 */
export function userIdFromAccessToken(token: string): string {
  try {
    const part = token.split(".")[1];
    const b64 = part
      .replace(/-/g, "+")
      .replace(/_/g, "/")
      .padEnd(Math.ceil(part.length / 4) * 4, "=");
    const sub = (JSON.parse(atob(b64)) as { sub?: unknown }).sub;
    return typeof sub === "string" ? sub : "";
  } catch {
    return "";
  }
}
